'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'sterling-sign';
var width = 320;
var height = 512;
var aliases = [163,"gbp","pound-sign"];
var unicode = 'f154';
var svgPathData = 'M112 157.9c0-34.2 27.7-61.9 61.9-61.9c7.9 0 15.7 1.5 23 4.4l63.2 25.3 29.7 11.9 23.8-59.4L283.9 66.3 220.7 41c-14.9-5.9-30.7-9-46.8-9C104.4 32 48 88.4 48 157.9L48 224 0 224l0 64 48 0 0 48.4L3.4 425.7 0 432.4 0 440l0 8 0 32 32 0 256 0 32 0 0-64-32 0L79.8 416l28.8-57.7 3.4-6.8 0-7.6 0-56 144 0 0-64-144 0 0-66.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSterlingSign = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;